// src/components/TermsOfService.jsx
import React from "react";

function TermsOfService() {
  return (
    <div style={{ padding: "1rem", maxWidth: "800px", margin: "0 auto" }}>
      {/* Main title (similar to .howto-title styling) */}
      <h1 className="howto-title">Terms of Service for Anonysis.io</h1>

      <p>
        These Terms of Service (“<strong>Terms</strong>”) govern your use of the 
        Anonysis.io website, services, and applications (collectively, the 
        “<strong>Service</strong>” or “<strong>we</strong>” or “<strong>us</strong>”). 
        By accessing or using the Service in any way, you agree to be bound by these 
        Terms. If you do not agree with any part of these Terms, you must not access 
        or use our Service.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing, browsing, or using Anonysis.io, you confirm that you have read, 
        understood, and agree to be legally bound by these Terms and all applicable 
        laws and regulations. We may update these Terms from time to time by posting 
        a new version on our website. Your continued use of the Service after any 
        changes to these Terms constitutes your acceptance of such changes.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least 13 years old (or 16 in certain jurisdictions) to use the 
        Service. If you are under the age required by local laws, you may only use the 
        Service under the supervision of a parent or legal guardian who agrees to be 
        bound by these Terms.
      </p>

      <h2>3. User Accounts</h2>
      <p>
        You may be required to create an account to access certain features of the 
        Service. You agree to provide accurate, current, and complete information 
        during the registration process. You are responsible for maintaining the 
        confidentiality of your account credentials and for all activities that occur 
        under your account.
      </p>

      <h2>4. User Conduct</h2>
      <p>
        You agree not to use the Service to:
      </p>
      <ul>
        <li>Violate any applicable law or regulation.</li>
        <li>Infringe upon any third-party right, including intellectual property rights.</li>
        <li>Upload or transmit viruses, malware, or other harmful code.</li>
        <li>Engage in any fraudulent, abusive, or otherwise illegal activity.</li>
        <li>Harvest or collect personal data or information of other users without their consent.</li>
      </ul>
      <p>
        We reserve the right to terminate or suspend your account if we determine, at 
        our sole discretion, that you have violated any part of these Terms.
      </p>

      <h2>5. Intellectual Property</h2>
      <p>
        All materials, content, and features of the Service (including but not limited 
        to text, graphics, designs, images, software, and source code) are owned by or 
        licensed to Anonysis.io and are protected by intellectual property rights. You 
        agree not to reproduce, distribute, modify, create derivative works of, publicly 
        display, publicly perform, republish, download, store, or transmit any of the 
        material on our Service except as permitted by these Terms.
      </p>

      <h2>6. Paid Services and Pricing</h2>
      <p>
        Some features of the Service may require payment. We will provide information 
        about pricing, subscription plans, or one-time fees on our Pricing or similar 
        page. By purchasing any paid feature, you agree to the pricing and payment 
        terms presented at the time of purchase. Pricing is subject to change at any time.
      </p>

      <h2>7. Disclaimer of Warranties</h2>
      <p>
        The Service is provided on an “AS IS” and “AS AVAILABLE” basis. We make no 
        warranties or representations about the accuracy, reliability, completeness, 
        or timeliness of the Service. To the fullest extent permitted by law, we 
        disclaim all warranties, whether express, implied, statutory, or otherwise, 
        including but not limited to the implied warranties of merchantability, fitness 
        for a particular purpose, and non-infringement.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        In no event shall Anonysis.io or its affiliates, officers, employees, agents, 
        or licensors be liable for any indirect, consequential, exemplary, incidental, 
        special, or punitive damages, including but not limited to lost profits, even 
        if advised of the possibility of such damages. Your sole and exclusive remedy 
        for dissatisfaction with the Service is to discontinue your use of the Service.
      </p>

      <h2>9. Indemnification</h2>
      <p>
        You agree to defend, indemnify, and hold harmless Anonysis.io and its affiliates, 
        officers, employees, agents, and licensors from and against any claims, liabilities, 
        damages, judgments, awards, losses, costs, expenses, or fees resulting from or 
        arising out of your use of the Service, your breach of these Terms, or your 
        violation of any law or the rights of a third party.
      </p>

      <h2>10. Termination</h2>
      <p>
        We may, at our sole discretion, terminate or suspend your account or access to 
        the Service at any time and for any reason, including a violation of these Terms. 
        Upon termination, your right to use the Service will immediately cease.
      </p>

      <h2>11. Changes to These Terms</h2>
      <p>
        We reserve the right to modify or replace these Terms at any time. If we make 
        a material change, we will provide notice to you, such as by posting a notice 
        on our website or sending an email. Your continued use of the Service following 
        any changes indicates your acceptance of the new Terms.
      </p>

      <h2>12. Governing Law</h2>
      <p>
        These Terms and any dispute arising out of or in connection with them will be 
        governed by and construed in accordance with the laws of [Your Jurisdiction], 
        without regard to its conflict of law provisions.
      </p>

      <h2>13. Contact Us</h2>
      <p>
        If you have any questions about these Terms, please contact us at: 
        <a href="mailto:info@anonysis.io"> info@anonysis.io</a>
      </p>

      <p><em>Thank you for using Anonysis.io!</em></p>
    </div>
  );
}

export default TermsOfService;
